import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const addons = async (id) => {
    const response = await axios.get(routes.addons(id), AXIOS_DEFAULT_CONFIG);
    return response;
}
export default addons;